import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class MeasureDescriptionReferenceService extends BaseReferenceService {
  constructor() {
    super('MeasureDescriptionReference');
  }
}
